import { gql } from "apollo-boost";

export const GET_ATHLETE_LIST = gql`
  query($clubId: Int,$email: String, $status: String, $competitiveFlag: Int) {
    allAthlete(clubId: $clubId,email: $email,status: $status,competitiveFlag: $competitiveFlag) {
      edges {
        node {
          athleteId
          firstName
          lastName
          status
          birthDate
          photo
          phone
          sourceOfInformation
          additionalInfo
          homeAddress
          postalCode
          occupation
          gender
          email
          language
          country
          createDate
          updateDate
          updateSource
          teamId
          leadId
          team {
            id
            teamName
            webpage
            competitiveFlag
          }            
          startMembership
          formsSigned
          participationDays
          registrationState
          tryoutDatetime
          volunteerHours
          clubId
          club {
            clubName
            website
          }
        }
      }
    }
  }
`;

export const GET_ATHLETE_RESULTS = gql`
  query($clubId: Int) {
    allResults(clubId: $clubId) {
      edges {
        node {
          athleteId
          resultDate
          resultTime
          isOfficial
          facilityType
          place
          comments
          meet {
            meetId
            meetName
          }
          set {
            distance
            stroke
            setDesc
          }
          athlete {
            firstName
            lastName
            gender
          }
        }
      }
    }
  }
`;
export const GET_RESULTS_LIST = gql`
  query resultsList(
    $gender: String
    $tagSl: String
    $leagueSeqno: Int
    $clubId: Int
    $teamId: Int
    $athleteId: Int
    $ageFrom: Int
    $ageTo: Int
    $stroke: String
    $fromDate: String
    $toDate: String
    $facilityType: String
    $bestOnly: Int
    $isNewDays: Int
    $rankClassification: String
    $inAthleteStatus: String
  ) {
    resultsList(
      gender: $gender
      tagSl: $tagSl
      leagueSeqno: $leagueSeqno
      clubId: $clubId
      teamId: $teamId
      athleteId: $athleteId
      ageFrom: $ageFrom
      ageTo: $ageTo
      stroke: $stroke
      fromDate: $fromDate
      toDate: $toDate
      facilityType: $facilityType
      bestOnly: $bestOnly
      isNewDays: $isNewDays
      rankClassification: $rankClassification
      inAthleteStatus: $inAthleteStatus
    ) {
      firstName
      resultTime
      resultDate
      distance
      stroke
      athRankName
      timeToNextRank
      isNew
      athRank
      setId
      setName
      athleteId
      place
      meetId
      comments
      gender
      facilityType
      resultId
      setLibSetId
      isOfficial
      points
      meetName
    }
  }
`;

export const GET_PERSON_COMMUNICATIONS = gql`
query allPersonCommunications($leadId: Int){
  allPersonCommunications(leadId: $leadId) {
    edges {
      node {
        seqNo
        leadId
        communicationType
        communicationResource
        subject
        details
        communicationDate
        followUpDate
        followUpStatus
        updateDate
        updateSource
      }
    }
  }
}
`;

export const GET_CLUB_PERSON_RELATIONSHIP = gql`
query allClubPersonRel($personId: Int,$clubId: Int){
  allClubPersonRel(personId: $personId,clubId: $clubId) {
    edges {
      node {
        seqNo
        role
        personId
        teamId
        eventId
        startMembership
        endMembership
        formsSigned        
        volunteerHours
        tryoutDatetime
        status
        additionalInfo
        person {
          firstName
          lastName
          registrationState
        }
        event {
          name
          eventType
          startDate
          endDate
        }
        group {
          teamName
        }
      }
    }
  }
}
`;